import { useCreateTask } from '@api';
import { TaskFormSchemaType, useNotification } from '@common';
import { AxiosError } from 'axios';
import { getCreateTaskData } from './helpers';

const TRANS_KEY = 'NOTIFICATIONS.CREATE_TASK';

type UseSubmitCreateTaskReturnType = {
  submitCreateTask: (data: TaskFormSchemaType) => Promise<void>;
};

export const useSubmitCreateTask = (): UseSubmitCreateTaskReturnType => {
  const { mutateAsync: createTask } = useCreateTask();
  const { showSuccess, showError } = useNotification();

  const onSuccess = (): void => {
    showSuccess({
      title: `${TRANS_KEY}.SUCCESS.TITLE`,
      message: `${TRANS_KEY}.SUCCESS.MESSAGE`,
    });
  };

  const onError = (error: AxiosError): void => {
    showError({
      title: `${TRANS_KEY}.ERROR.TITLE`,
      message: `${TRANS_KEY}.ERROR.MESSAGE`,
      error,
    });
  };

  const submitCreateTask = async (
    data: TaskFormSchemaType
  ): Promise<void> => {
    await createTask(
      {
        data: getCreateTaskData({ values: data }),
      },
      { onSuccess, onError }
    );
  };

  return { submitCreateTask };
};
